const SECURITY_CONTEXT_COOKIE = 'x-egto-security-context';
const MAIN = 'MAIN';
const EXTRANET = 'EXTRANET';

// Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find?v=control
//
// https://tc39.github.io/ecma262/#sec-array.prototype.find
// NB! This is a quick'n'dirty fix to make login work in Internet Exploder
// This polyfill should be moved to a generic polyfill.js file somewhere appropriate,
// so everybody can benefit from this useful function
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this === null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}

/* @ngInject */
export function destinationInstallation(destinationService) {
    return destinationService.getDestinationInstallation();
}

/* @ngInject */
export function chosenAuthenticationMechanisms(chooseMechanismService) {
    return chooseMechanismService.query();
}

/* @ngInject */
export function chooseMechanismRedirectResolve(destinationService, chooseMechanismService, $cookies){
    destinationService.getDestinationInstallation().then((response) => {
        let destinationInstallation = response;
        let installationAuthenticationMechanisms = destinationInstallation ? destinationInstallation.installationAuthenticationMechanisms : [];
        let securityContextCookie = $cookies.get(SECURITY_CONTEXT_COOKIE);
        let securityContext = securityContextCookie ? securityContextCookie.toUpperCase() : 'MAIN';

        let nspIdCardRequired = $cookies.get('x-egto-nsp-id-card-required');
        if (nspIdCardRequired) {
            installationAuthenticationMechanisms = installationAuthenticationMechanisms.filter(
                mechanism => mechanism.nspEnabled
            );
            $cookies.remove('x-egto-nsp-id-card-required');
        }

        if(!destinationInstallation || installationAuthenticationMechanisms.length === 0){
            return chooseMechanismService.redirectToFormLogin();
        }

        if (installationAuthenticationMechanisms.length === 1 && installationAuthenticationMechanisms[0].authenticationMechanism.type === 'PASSWORD_CREDENTIALS') {
            return chooseMechanismService.redirectToFormLogin();
        }

        switch (securityContext) {
            case EXTRANET: {
                let extranetMechanism = installationAuthenticationMechanisms.find(isExtranet);
                if (!extranetMechanism) {
                    break;
                }
                let activeMainMechanismCount = installationAuthenticationMechanisms.filter(isActive).filter(isExtranet).length;
                if (activeMainMechanismCount > 1 ) {
                    return chooseMechanismService.redirectChooseMechanism();
                }
                setChosenMechanism(extranetMechanism, chooseMechanismService);
                return chooseMechanismService.redirectToFormLogin();
            }
            case MAIN: {
                let chosenAuthenticationMechanisms = $cookies.get('x-egto-authentication-mechanisms-chosen');
                let defaultMechanism = installationAuthenticationMechanisms.filter(isMain).find(isDefaultMechanism);
                if (chosenAuthenticationMechanisms === undefined && defaultMechanism) {
                    setChosenMechanism(defaultMechanism, chooseMechanismService);
                    return chooseMechanismService.redirectToSingleMechanism();
                }
                let activeMainMechanismCount = installationAuthenticationMechanisms.filter(isActive).filter(isMain).length;
                if (activeMainMechanismCount > 1 ) {
                    return chooseMechanismService.redirectChooseMechanism();
                }
                let mainMechanism = installationAuthenticationMechanisms.filter(isActive).find(isMain);
                setChosenMechanism(mainMechanism, chooseMechanismService);
                return chooseMechanismService.redirectToSingleMechanism();
            }
        }
    });
}

function setChosenMechanism(mechanism, chooseMechanismService) {
    chooseMechanismService.choose(mechanism, "");
}

function isExtranet(mechanism) {
    return mechanism.securityContext === EXTRANET;
}

function isMain(mechanism) {
    return mechanism.securityContext === MAIN;
}

function isActive(mechanism) {
    return mechanism.active === true;
}

function isDefaultMechanism(mechanism) {
    return mechanism.defaultMechanism === true;
}
